export default __webpack_public_path__ + "static/media/tick.fed63d77.svg";